import type { UiState } from 'instantsearch.js';
import { Configure } from 'react-instantsearch-core';

import { InstantSearchStateUpdater } from '@/components/InstantSearchUpdater/InstantSearchUpdater';
import { FILTERS_FETCH_LIMIT } from '@/lib/const';

export const SearchConfiguration = ({
  algoliaCategoryId,
  algoliaFilters,
  algoliaRuleName,
  asPath,
  pageIndex,
  uiStateFromURL,
  userToken,
}: {
  algoliaCategoryId: string;
  algoliaFilters: string;
  algoliaRuleName: string;
  asPath: string;
  pageIndex?: number | '';
  uiStateFromURL: UiState;
  userToken?: string;
}) => (
  <>
    <InstantSearchStateUpdater key={asPath} expectedUiState={uiStateFromURL} />
    <Configure
      analyticsTags={[
        'platform:web',
        'product:watches',
        'page:listing',
        'context:editorial',
        'rule:' + algoliaRuleName,
        'category:' + algoliaCategoryId,
      ]}
      clickAnalytics={true}
      distinct={true}
      facetingAfterDistinct={true}
      facets={['*']}
      filters={algoliaFilters}
      maxValuesPerFacet={FILTERS_FETCH_LIMIT}
      userToken={userToken}
      {...(typeof pageIndex === 'number' && pageIndex > 0
        ? { page: pageIndex - 1 }
        : {})}
      {...(algoliaRuleName ? { query: algoliaRuleName } : {})}
      {...(algoliaCategoryId
        ? { facetFilters: [[`category_page_id:${algoliaCategoryId}`]] }
        : {})}
    />
  </>
);

export default SearchConfiguration;
